import {
  SAVE_ADDRESS_FAILED,
  SAVE_ADDRESS_SUCCESS,
  SAVE_ADDRESS_INVALID_REQUEST,
  SAVE_ADDRESS_NOT_FOUND,
  LOADING_SAVE_ADDRESS,
  RESET_SAVE_ADDRESS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SAVE_ADDRESS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
      };

    case SAVE_ADDRESS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        status: "Failed to save adress, please try again!",
      };
    case SAVE_ADDRESS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        status: "Oops, something went wrong!",
      };

    case SAVE_ADDRESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        status: "Address saved sucessfully",
      };

    case RESET_SAVE_ADDRESS:
      return (state = initialState);

    default:
      return state;
  }
};
